export const VIDEO = "VIDEO"
export const COURSE = "COURSE"
export const AUTHOR = "AUTHOR"
export const CERTIFICATION = "CERTIFICATION"
export const WEBINAR = "WEBINAR"
export const SUBSCRIPTION = "SUBSCRIPTION"
export const GIFT_CARD = "GIFT_CARD"
export const BUNDLE = "BUNDLE"
export const PATH = "PATH"
